import DelegationsFulfillment from './delegations-fulfillment-view'

export default DelegationsFulfillment
